var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voodoo-step",class:_vm.$style.wrapper,style:({ backgroundColor: _vm.color, opacity:  _vm.isAccessible? 1: 0.2})},[_c('p',{staticStyle:{"color":"white"}},[_vm._v("Click to validate")])])
}
var staticRenderFns = []

export { render, staticRenderFns }